/**
 * A photograph chosen somewhere other than the editor, waiting for the editor to
 * open on it.
 *
 * A reader who meets a climb with no picture meets it on the climb's own page, and
 * that is where the camera is offered — but the picture means nothing until the
 * climb is circled on it, which happens in the editor. So the file is handed
 * across rather than asked for twice.
 *
 * Held in memory rather than in the router's state: history state is
 * structured-cloned into the browser's session store, and a four-megabyte photo
 * has no business there. One slot, marked with the climb it was picked for, so a
 * file chosen for one climb cannot turn up on another — and *taken* rather than
 * read, so coming back to the editor later starts from the camera, as it always
 * did. A reload loses it, which is the same thing: the editor opens on its own
 * photo screen.
 */
let pending: { climbSlug: string; file: File } | null = null;

/** Keep this picture for the editor of that climb. */
export function holdPhotoFor(climbSlug: string, file: File): void {
  pending = { climbSlug, file };
}

/** The picture picked for this climb, once. Null when there is none. */
export function takePhotoFor(climbSlug: string): File | null {
  if (pending?.climbSlug !== climbSlug) return null;

  const { file } = pending;
  pending = null;
  return file;
}
